import { appConfig } from "src/config";

export const CRAFTY_CLICKS_URLS = {
  find: appConfig.CRAFTY_CLICKS_FIND_URL,
  retrieve: appConfig.CRAFTY_CLICKS_RETRIEVE_URL,
  countries: appConfig.CRAFTY_CLICKS_COUNTRIES_URL
};
